const ERROR_MESSAGES = {
    rest_collections_fetch_failed: 'Không thể tải danh sách. Vui lòng thử lại.',
    rest_collection_creation_failed: 'Không thể tạo danh sách mới. Vui lòng thử lại.',
    rest_collection_update_failed: 'Không thể cập nhật danh sách.',
    rest_collection_delete_failed: 'Không thể xóa danh sách.',
    rest_collection_items_fetch_failed: 'Không thể tải các dự án trong danh sách.',
    rest_collection_item_add_failed: 'Không thể thêm dự án vào danh sách đã chọn.',
    rest_collection_item_remove_failed: 'Không thể xóa dự án khỏi danh sách.',
    rest_collection_duplicate_failed: 'Không thể nhân bản danh sách.',
    rest_collection_visibility_update_failed: 'Không thể thay đổi trạng thái công khai của danh sách.',
    rest_collection_tags_failed: 'Không thể tải danh sách tags.',
    rest_collection_search_failed: 'Không thể tìm kiếm danh sách.',
    rest_collection_forbidden: 'Bạn không có quyền thao tác với danh sách này.',
    rest_view_count_update_failed: 'Không thể cập nhật lượt xem cho danh sách công khai.',
};

export function normaliseCollectionError(rawError, fallback = 'Đã xảy ra lỗi, vui lòng thử lại.') {
    if (!rawError) {
        return fallback;
    }

    const data = rawError?.data ?? {};
    const code = data.code || rawError.code;
    let message = data.message || rawError.message || fallback;

    if (code && ERROR_MESSAGES[code]) {
        return ERROR_MESSAGES[code];
    }

    if (code === 'rest_invalid_param') {
        if (typeof data?.params === 'object') {
            if (data.params.collection_ids) {
                const paramMessage = Array.isArray(data.params.collection_ids)
                    ? data.params.collection_ids.join(' ')
                    : data.params.collection_ids;
                if (paramMessage?.includes('non-empty')) {
                    return 'Vui lòng chọn ít nhất một danh sách.';
                }
            }
        }
    }

    const lowerMessage = (message || '').toLowerCase();
    if (lowerMessage.includes('more than 50 collections') || lowerMessage.includes('50 collections')) {
        return 'Bạn chỉ có thể thao tác tối đa 50 danh sách trong một lần.';
    }
    if (lowerMessage.includes('maximum collections limit')) {
        return 'Bạn đã đạt giới hạn số lượng danh sách cho phép (100).';
    }
    if (lowerMessage.includes('collection item limit')) {
        return 'Danh sách đã đạt số lượng dự án tối đa.';
    }
    if (lowerMessage.includes('non-empty array')) {
        return 'Vui lòng chọn ít nhất một danh sách.';
    }

    return message || fallback;
}
